import { useHistory } from "react-router-dom";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : MenuItems
Description : Componente que contiene la información de los botones de la barra de navegación de la aplicación
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se defienen los botones de la barra de navegación.
================================================================================ */
export default function MenuItems5() {
    let history = useHistory();
    const items = [
        {
            label: 'Certificados',
            path: "/Certificate",
            index: 0,
        },
        {
            label: 'Nómina',
            path: "/Voucher",
            index: 1,
        },
        {
            label: 'Ingresos y retenciones',
            path: "/CIRVoucher",
            index: 2,
        },
        {
            label: 'Retefuente',
            path: "/Retefuente",
            index: 3,
        },
    ]
    return items
}
